{
  "nl": {
    "aiPrivacyNotice": {
      "backToChat": "Terug naar AI-chat",
      "pupil": {
        "facts": {
          "aiDoesNotKnowYou": "De AI kent je niet, zolang je geen persoonlijke gegevens deelt.",
          "teacherCanSee": "Je docent kan zien wat je doet en wie je bent."
        },
        "policyLink": "Meer over privacy lezen",
        "rules": {
          "doubtAnswers": "Ik geloof niet alles wat de AI zegt.",
          "heading": "Twee regels als je de AI gebruikt:",
          "noPrivateData": "Ik vertel de AI niet mijn echte naam of andere privézaken."
        },
        "title": "Zo bescherm je je gegevens"
      },
      "teacher": {
        "handling": {
          "detail": "De aanbieders verwijderen verzoeken na uiterlijk 30 dagen.",
          "heading": "Hoe je gegevens worden behandeld",
          "text": "Geen training van AI-modellen."
        },
        "intro": "Voor een antwoord stuurt fobizz je invoer naar de AI-dienstverlener die je hebt gekozen.",
        "notTransmitted": {
          "detail": "De aanbieder kan je niet identificeren.",
          "heading": "Wat we niet verzenden",
          "text": "Naam, e\u2011mail, gebruikers\u2011ID, school of IP\u2011adres."
        },
        "policyLink": "Naar de volledige privacyverklaring",
        "title": "Datagebruik door AI-diensten",
        "transmitted": {
          "detail": "(Afbeeldingen, audio, PDF, tekst)",
          "heading": "Wat we verzenden",
          "text": "Je teksten en geüploade bestanden"
        }
      }
    }
  }
}
